import { createAction, props } from '@ngrx/store';
import { Securable } from './model';

export const updateCache = createAction(
  '[Securable] Update Cache',
  props<{ securables: Securable[] }>()
);

export const clearCache = createAction('[Securable] Clear Cache');
